import { SITE_URL } from '../config/seoConfig';

/**
 * Generate BreadcrumbList schema for navigation
 * @param {Array} items - Array of breadcrumb items
 * @param {string} items[].name - Display name for the breadcrumb
 * @param {string} items[].path - Path without language prefix (e.g., '/catalog')
 * @param {string} lang - Language code
 */
export const generateBreadcrumbSchema = (items, lang = 'en') => {
  if (!items || !Array.isArray(items) || items.length === 0) {
    return null;
  }

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.path === '' || item.path === '/'
        ? `${SITE_URL}/${lang}`
        : `${SITE_URL}/${lang}${item.path.startsWith('/') ? item.path : '/' + item.path}`,
    })),
  };
};
